import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { assets } from '../../assets';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--primary-text-color);
  font-size: 12px;
`;

const Checkbox = styled.div.attrs(() => ({}))<{ checked: boolean; inactive: boolean }>`
  height: 24px;
  width: 24px;
  margin-right: 8px;
  background: ${(props) => (props.checked ? 'var(--primary-color)' : 'var(--primary-text-color)')};
  border-radius: 2px;
  border: 2px solid var(--primary-color);
  display: flex;
  opacity: ${(props) => (props.inactive ? '0.5' : '1')};
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.inactive ? 'not-allowed' : 'pointer')};
  flex: none;
`;

const CheckIcon = styled.img`
  width: 12px;
  height: 12px;
  object-fit: contain;
`;

const StyledCheckbox = (props: {
  onChange: (checked: boolean) => void;
  checked: boolean;
  inactive?: boolean;
  children?: ReactNode;
}): JSX.Element => {
  const [value, setValue] = useState(props.checked || false);

  const handleChange = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    event.stopPropagation();
    if (!props.inactive) {
      props.onChange(!value);
      setValue(!value);
    }
  };

  return (
    <Wrapper>
      <Checkbox checked={value} onClick={handleChange} inactive={!!props.inactive}>
        {value && <CheckIcon src={assets.icons.checkbox_icon} />}
      </Checkbox>
      <div className={props.inactive ? 'text-gray' : undefined}>{props.children}</div>
    </Wrapper>
  );
};

export default StyledCheckbox;
